/**
 * @module:  js与native交互核心模块
 * @author: Liang Huang
 * @date: 2019-09-18 23:02:09
 * @description: h5和原生交互，jsbridge核心代码
 * @requires showError，globalError，os
 */
import shortid from 'shortid';
import { warn } from '../utils/debug';
import { showError } from './error';
import globalerror from '../inner/globalerror';

function iOSFunc(data) {
  try {
    if (!window.webkit) {
      window.WKWebViewJavascriptBridge && window.WKWebViewJavascriptBridge.postMessage(data);
    } else {
      window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(data);
    }
  } catch (error) {
    console.error('iOS hybrid bridge error');
  }
}

export default function jsBridgeMixin(hybrid) {
  var hybridJS = hybrid; // 必须要有一个全局的JSBridge，否则原生和H5无法通信
  // 定义每次重新生成一个JSBridge

  window.JSBridge = window.JSBridge || {};
  var JSBridge = window.JSBridge;
  var os = hybridJS.os;
  hybridJS.JSBridge = JSBridge;
  var messageHandlers = {};
  var responseCallbacks = {};
  /**
   * 将JSON参数转为字符串
   * @param {Object} data 对应的json对象
   * @return {String} 转为字符串后的结果
   */
  // function getParam(data) {
  //   try {
  //     return (typeof data === 'string') ? data : JSON.stringify(data);
  //   } catch (error) {
  //     throw new Error(error);
  //   }
  // }

  function send(data, responseCallback) {
    if (typeof responseCallback === 'function') {
      // 生成唯一的callbackId
      var callbackId = shortid.generate();
      responseCallbacks[callbackId] = responseCallback;
      data.callbackId = callbackId;
    } else {
      data.callbackId = responseCallback;
    }

    if (os.ywk) {
      if (os.ios) {
        iOSFunc(data);
      } else {
        window.JSBridge.invoke(JSON.stringify(data));
      }
    } else {
      // 浏览器
      warn("\u6D4F\u89C8\u5668\u4E2Djsbridge\u65E0\u6548,\u5BF9\u5E94" + data.handlerName);
    }
  }
  /**
   * 注册本地JS方法通过JSBridge给原生调用
   * 我们规定,原生必须通过JSBridge来调用H5的方法
   * 注意,这里一般对本地函数有一些要求,要求第一个参数是data,第二个参数是callback
   * @param {String} handlerName 方法名
   * @param {Function} handler 对应的方法
   */


  JSBridge.registerHandler = function (handlerName, handler) {
    messageHandlers[handlerName] = handler;
  };
  /**
   * 调用原生开放的方法
   * @param {String} moduleName 模块名称
   * @param {String} handlerName 方法名
   * @param {JSON} data 参数
   * @param {Object} callback 回调函数
   */


  JSBridge.callHandler = function (moduleName, handlerName, data, callback) {
    send({
      handlerName: moduleName + "." + handlerName,
      data: data
    }, callback);
  };

  JSBridge._handleMessageFromNative = function (messageJSON) {
    /**
     * 处理原生过来的方法
     */
    function doDispatchMessageFromNative() {
      var message;

      try {
        if (typeof messageJSON === 'string') {
          message = decodeURIComponent(messageJSON);
          message = JSON.parse(message);
        } else {
          message = messageJSON;
        }
      } catch (error) {
        showError(globalerror.ERROR_TYPE_NATIVE_CALL);
        return;
      }

      var responseId = message.responseId,
          responseData = message.responseData;
      var responseCallback;

      if (responseId) {
        // 这里规定,原生执行方法完毕后准备通知h5执行回调时,回调函数id是responseId
        responseCallback = responseCallbacks[responseId];
        responseCallback && responseCallback(responseData);
        delete responseCallbacks[responseId];
      } else {
        /**
         * 否则,代表原生主动执行h5本地的函数
         * 从本地注册的函数中获取
         */
        var handler = messageHandlers[message.handlerName];
        var data = message.data; // 执行本地函数,按照要求传入数据和回调

        handler && handler(data);
      }
    } // 使用异步


    setTimeout(doDispatchMessageFromNative);
  };
}